// Превращает относительные пути загрузок (/uploads/... или /api/uploads/...)
// в абсолютные через API-сервер, т.к. админка может работать с другого origin
export const resolveMediaUrl = (url) => {
    if (!url || /^(https?:|blob:|data:)/i.test(url)) {
        return url;
    }

    const uploadsMatch = url.match(/^(?:\/api)?(\/uploads\/.+)$/);
    if (!uploadsMatch) {
        return url;
    }

    // REACT_APP_API_URL вида http://localhost:4200/api
    const apiUrl = (process.env.REACT_APP_API_URL_IMG || '').trim().replace(/\/+$/, '');
    if (!apiUrl) {
        return `/api${uploadsMatch[1]}`;
    }

    return `${apiUrl}${uploadsMatch[1]}`;
};
